export const LINKS = {
  phone: 'tel:+380978865177',
  whatsapp: 'https://wa.me/380978865177',
  telegram: 'https://t.me/+380978865177',
  viber: 'viber://chat?number=%2B380978865177',
  signal: 'https://signal.me/#p/+380978865177',
  email: 'mailto:annatransfer2016@gmail.com',
  linkedin:
    'https://www.linkedin.com/in/%D1%96%D0%B2%D0%B0%D0%BD-%D0%BF%D0%B8%D0%BB%D1%8F%D0%B2%D0%B5%D1%86%D1%8C-76445b358/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
};
